/** <select>가 문자열 "false"를 줄 수 있어 boolean으로 강제 변환. "false"만 false. */
export function coerceSelectBoolean(v: unknown): boolean {
  return String(v) !== "false";
}
